/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AvailabilityDetail = {
    availabilityId?: number;
    offerId?: number;
    datetime?: number;
    availabilityStatus?: AvailabilityDetail.availabilityStatus;
    price?: number;
    tourId?: number;
    comment?: string;
    vanliferFirstname?: string;
    vanliferLastname?: string;
    vanliferMail?: string;
    vanliferPhone?: string;
    available?: boolean;
    reserved?: boolean;
    booked?: boolean;
};
export namespace AvailabilityDetail {
    export enum availabilityStatus {
        AVAILABLE = 'AVAILABLE',
        RESERVED = 'RESERVED',
        BOOKED = 'BOOKED',
        BOOKED_BY_HOST = 'BOOKED_BY_HOST',
    }
}

